import type { SetupCandle, SetupPattern } from "./setup";

/**
 * Where the reveal's setup sentence (`setupStats.ts`) sends a reader who
 * wants to look a term up. Investopedia term pages, chosen for plain
 * definitions with no trading advice attached, matching this feature's own
 * "description, not a recommendation" stance (GRA-141).
 *
 * Both flag labels and both wedge labels share one page each: Investopedia
 * covers "bull flag"/"bear flag" and "rising wedge"/"falling wedge" as one
 * article apiece, so `bull_flag` and `bear_flag` point at the same URL, as do
 * the two wedge labels.
 *
 * Verified live against the Wayback Machine (this network blocks Investopedia
 * itself with a blanket 402): every URL below resolved 200 as of its most
 * recent capture. `inside-days.asp` is the one place the obvious guess
 * (`inside-day.asp`, singular) is wrong; Investopedia's actual slug is plural.
 */
export const CANDLE_GLOSSARY_URL: Record<SetupCandle, string> = {
  doji: "https://www.investopedia.com/terms/d/doji.asp",
  hammer: "https://www.investopedia.com/terms/h/hammer.asp",
  shooting_star: "https://www.investopedia.com/terms/s/shootingstar.asp",
  bullish_engulfing: "https://www.investopedia.com/terms/b/bullishengulfingpattern.asp",
  bearish_engulfing: "https://www.investopedia.com/terms/b/bearishengulfingp.asp",
  inside_bar: "https://www.investopedia.com/terms/i/inside-days.asp",
};

export const PATTERN_GLOSSARY_URL: Record<SetupPattern, string> = {
  head_and_shoulders: "https://www.investopedia.com/terms/h/head-shoulders.asp",
  inverse_head_and_shoulders: "https://www.investopedia.com/terms/i/inverseheadandshoulders.asp",
  double_top: "https://www.investopedia.com/terms/d/doubletop.asp",
  double_bottom: "https://www.investopedia.com/terms/d/doublebottom.asp",
  bull_flag: "https://www.investopedia.com/terms/f/flag.asp",
  bear_flag: "https://www.investopedia.com/terms/f/flag.asp",
  rising_wedge: "https://www.investopedia.com/terms/w/wedge.asp",
  falling_wedge: "https://www.investopedia.com/terms/w/wedge.asp",
};
